<template>
  <div class="gallery">
    <div class="image">
      <img :src="mainImage" alt="" />
      <a class="zoom-link">
        <img src="/images/icons/zoom.svg" alt="" class="zoom" @click="toggleImage(mainImage)" />
      </a>
    </div>
    <div class="thumbs">
      <div
        v-for="(t, index) in thumbs"
        :key="index"
        class="thumb"
        :class="{ active: currentImage === index }"
        @click="setMain(t, index)"
      >
        <img :src="t" alt="" />
      </div>
    </div>

    <div class="popup-module" v-if="modalIsOpen">
      <span class="background" @click="toggleImage"></span>

      <div class="img-content">
        <img :src="zoomImage" alt="bigImage">
      </div>
    </div>

  </div>
  
</template>
<script>
export default {
  props: {
    thumbs: Array,
    main_image: String
  },
  data() {
    return {
      mainImage: '',
      modalIsOpen: false,
      // sampleMainImage:
      //   '/images/placeholder/product-detail/product-detail-1.png',
      // sampleThumbs: [
      //   '/images/placeholder/product-detail/prod-dtl-thumb-1.png',
      //   '/images/placeholder/product-detail/prod-dtl-thumb-1.png',
      //   '/images/placeholder/product-detail/prod-dtl-thumb-1.png',
      //   '/images/placeholder/product-detail/prod-dtl-thumb-1.png'
      // ],
      zoomImage: '',
      currentImage: 0
    }
  },

  mounted() {
    this.mainImage = this.main_image
    console.log(this.mainImage);
    // this.mainImage = this.sampleMainImage
  },

  methods: {
    setMain(img, index) {
      console.log(img)
      this.currentImage = index
      this.mainImage = img
    },
    toggleImage(img) {
      if(this.modalIsOpen) {
        this.zoomImage = ''
        this.modalIsOpen = false
      }else {
        this.modalIsOpen = true
        this.zoomImage = img
      }
    },

    closeZoom() {
      this.zoomImage = ''
    }
    
  }
}
</script>

<style lang="scss">
  .zoom {
    cursor: pointer;
  }
  .popup-module {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    width: 100% !important;
    height: 100%;

    .background {
      position: absolute;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;

      cursor: pointer;
      // background: rgb(0 0 0 / 50%);
    }

    article {
      position: absolute;
      top: 50%;
      left: 50%;

      width: 90%;
      max-width: 971px;
      max-height: 90%;
      margin: auto;
      padding: 20px;
      transform: translate(-50%, -50%);

      background-color: white;

      overflow: auto;

      // @media (min-width: $medium) {
      //   padding: 40px;
      // }

      .exit {
        position: absolute;
        top: 20px;
        right: 20px;

        width: 24px;
        height: 24px;

        cursor: pointer;

        // @media (min-width: $medium) {
        //   top: 40px;
        //   right: 60px;
        // }
      }

      .text {
        padding: 20px;

        // @media (min-width: $medium) {
        //   padding: 20px 0 20px 60px;
        // }
      }
    }

    .img-content {
      display: flex;
      align-items: center;
      justify-content: center;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 55%;

      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ProductImages.vue